'use client'
import React from 'react'
import ButtonCustom from '@/shared/components/ButtonCustom'
import { useRouter } from 'next/navigation'
import { StatusProps } from './StatusPageProps'
import { typesIcon } from './typesIcon'

export const StatusPage = ({
	title,
	buttonText,
	path,
	children,
	type = 'warning',
	closeButton = true,
	idButton,
	action,
}: StatusProps) => {
	const router = useRouter()

	const handleContinue = () => {
		if (action) {
			return action()
		}
		path && router.push(path)
	}

	return (
		<div className="relative flex flex-col justify-end h-screen ">
			{closeButton && (
				<button
					className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 focus:outline-none"
					onClick={handleContinue}
				>
					<span className="text-4xl">&times;</span>
				</button>
			)}
			<div className="flex justify-end mt-6">{typesIcon[type]}</div>
			<div className="flex flex-col justify-center h-[90%] mb-4 px-6">
				<h1 className="font-semibold text-4xl my-9">{title}</h1>
				<div className="flex flex-col justify-between h-full gap-9">
					<div className="text-[#37474F] tracking-[0.75px]">{children}</div>
					{
						buttonText && (
							<div className="mb-8">
								<ButtonCustom id={idButton} onClick={handleContinue}>
									{buttonText}
								</ButtonCustom>
							</div>
						)
					}
				</div>
			</div>
		</div>
	)
}
